import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";
import { Dayjs } from "dayjs";
import { safeDayjs } from "../../../helpers";

interface IVideoCreate {
  name: string;
  leagueId: number | string;
  link: string;
  img?: string;
  date?: string | Dayjs;
}

export const videoDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    getList: async () => {
      const url = "/cms/video/get";
      try {
        const { data } = await httpClient.get(url);
        // Convert date strings to dayjs objects for proper form handling
        if (Array.isArray(data)) {
          data.forEach((item: any) => {
            if (item && item.date) {
              item.date = safeDayjs(item.date);
            }
          });
        }
        return { data };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getOne: async ({ id }) => {
      const url = "/cms/video/get";
      try {
        const { data } = await httpClient.get(url, { params: { id } });
        const item = data[0];
        // Convert date string to dayjs object for proper form handling
        if (item && item.date) {
          item.date = safeDayjs(item.date);
        }
        return { data: item };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    update: async ({
      id,
      variables,
    }: {
      id: number;
      variables: IVideoCreate;
    }) => {
      const { name, leagueId, link, img, date } = variables;
      const url = "/cms/video/update";
      try {
        const { data } = await httpClient.post(url, {
          id,
          name,
          leagueId,
          link,
          img,
          date: date ? safeDayjs(date)?.format("YYYY-MM-DDTHH:mm") : undefined,
        });
        // Convert date string back to dayjs object for proper form handling
        if (data && data.date) {
          data.date = safeDayjs(data.date);
        }
        return { data };
      } catch (error) {
        return Promise.reject(error);
      }
    },
    create: async ({ variables }: { variables: IVideoCreate }) => {
      const { name, leagueId, link, img, date } = variables;
      const url = "/cms/video/add";
      try {
        await httpClient.post(url, {
          name,
          leagueId,
          link,
          img,
          date: date ? safeDayjs(date)?.format("YYYY-MM-DDTHH:mm") : undefined,
        });
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    deleteOne: async ({ id }: { id: number }) => {
      const url = "/cms/video/remove";
      try {
        const { data } = await httpClient.get(url, { params: { id } });
        return { data };
      } catch (error) {
        return Promise.reject(error);
      }
    },
    getApiUrl: () => apiUrl,
  };
